export const clearStorage = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("expirationTime");
  localStorage.removeItem("refresh-token");
  localStorage.clear();
};
